import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	fetchErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fetchErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fetchErrorFlagTitle: {
		id: 'project-create-importer.upload-flow.fetch-error-flag-title',
		defaultMessage: 'AI generation error',
		description: 'Flag title for fetch AI generation error',
	},
	fetchErrorFlagDescription: {
		id: 'project-create-importer.upload-flow.fetch-error-flag-description',
		defaultMessage: 'There was an error generating a response. Please wait a while and try again.',
		description: 'Flag description for fetch AI generation error',
	},
});
export default messages;
